import { Injectable, OnDestroy } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class TranslateDatepickerIntl extends MatDatepickerIntl implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) {
    super();
    this.updateLabels();
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateLabels();
      this.changes.next();
    });
  }

  private updateLabels(): void {
    this.calendarLabel = this.translate.instant('common.datepicker.calendar_label');
    this.openCalendarLabel = this.translate.instant('common.datepicker.open_calendar');
    this.closeCalendarLabel = this.translate.instant('common.datepicker.close_calendar');
    this.prevMonthLabel = this.translate.instant('common.datepicker.prev_month');
    this.nextMonthLabel = this.translate.instant('common.datepicker.next_month');
    this.prevYearLabel = this.translate.instant('common.datepicker.prev_year');
    this.nextYearLabel = this.translate.instant('common.datepicker.next_year');
    this.prevMultiYearLabel = this.translate.instant('common.datepicker.prev_multi_year');
    this.nextMultiYearLabel = this.translate.instant('common.datepicker.next_multi_year');
    this.switchToMonthViewLabel = this.translate.instant('common.datepicker.switch_to_month_view');
    this.switchToMultiYearViewLabel = this.translate.instant('common.datepicker.switch_to_multi_year_view');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
